import { Component, OnInit, Input, AfterViewInit, OnDestroy } from '@angular/core';
import * as _ from 'underscore';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { CONSTANTS, EVENT_EMITTERS, COLORS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';

import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';

@Component({
	selector: 'app-social-demographics-r1',
	templateUrl: './social-demographics-r1.component.html',
	styleUrls: ['./social-demographics-r1.component.css']
})
export class SocialDemographicsR1Component implements OnInit, AfterViewInit, OnDestroy {
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() downloadconfig: any;
	@Input() sectionclass: any;

	public downloadConfiguration: DownloadConfig;

	public reloadSubscription;
	public showLoad = true;
	public colorPalette: ColorPalette;
	public hasData = true;
	public widgetDataSubscription;
	public demographicData;
	public totalImpressions;
	public totalClicks;
	public colorPalatte: ColorPalette;
	objectKeys = Object.keys;
	public clickState = true;
	public impressionsState = true;
	public activeIndex;
	public selectedGender = 'female';
	public chartArrData = {};
	public donutChartData = {};
	public chartConfigObj = {
		svgHeight: 200,
		svgWidth: 181,
		seriesName: '',
		xLegendPos: 0,
		yLegendPos: 0,
		innerSize: '100',
		followPointer: false,
		tooltipColor: '#FFF',
		showPercentageToolTip: false,
		tolltipBorderWidth: 2,
		sigleLineToolTip: true,
		tooltipFontSize: '11px',
		tooltipBackgroundColor: null,
		tooltipTextColor: '#000',
		addSeriesNameToLables: true,
		size: '100%',
		verticalAlign: 'middle',
		legendText: '',
		datalabelsEnabled: false,
		dataLabelsDistance: 5,
		lineBreak: undefined,
		isTooltipEnabled: true,
		margin: [20, 20, 20, 20],
		type: 'pieDonut',
		legendItemDistance: 100,
		enableCustomLegend: true,
		customLegendData: undefined
	};

	constructor(
		private analyticsService: AnalyticsService,
		private analyticsDataModel: AnalyticsDataModel,
		private colorUtilityService: ColorUtilityService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit() {
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
	}

	ngAfterViewInit() {
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.requestData();
	}

	setGenderData(gender, index) {
		this.selectedGender = gender;
		this.activeIndex = index;
		this.updateChart();
	}

	requestData() {
		this.showLoad = true;
		this.hasData = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success && response.data.length > 0) {
				this.hasData = true;
				this.totalImpressions = response.data.reduce(function (accumulator, currentValue, currentIndex, array) {
					return accumulator + parseInt(currentValue.impressions != null ? currentValue.impressions : 0);
				}, 0);
				this.totalClicks = response.data.reduce(function (accumulator, currentValue, currentIndex, array) {
					return accumulator + parseInt(currentValue.clicks != null ? currentValue.clicks : 0);
				}, 0);
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(response) {
		const demographicDataGroupedByGender: any = _.groupBy(response, 'gender');
		// tslint:disable-next-line: forin
		for (const gender in demographicDataGroupedByGender) {
			demographicDataGroupedByGender[gender] = _.groupBy(demographicDataGroupedByGender[gender], 'age_group');
		}
		this.demographicData = demographicDataGroupedByGender;
		// tslint:disable-next-line: forin
		for (const key in this.demographicData) {
			this.chartArrData[key] = {};
			// tslint:disable-next-line: forin
			for (const ageGroup in this.demographicData[key]) {
				const ageGroupImpressions = this.demographicData[key][ageGroup].reduce(function (
					accumulator,
					currentValue,
					currentIndex,
					array
				) {
					return accumulator + parseInt(currentValue.impressions);
				},
				0);
				const ageGroupClicks = this.demographicData[key][ageGroup].reduce(function (
					accumulator,
					currentValue,
					currentIndex,
					array
				) {
					return accumulator + parseInt(currentValue.clicks);
				},
				0);
				this.chartArrData[key][ageGroup] = [
					{
						type: 'pie',
						size: '100%',
						innerSize: '60%',
						name: 'Impressions',
						data: [
							{
								name: 'Impressions',
								y: ageGroupImpressions,
								color: this.colorUtilityService.getRGBByColorType(this.colorPalette, COLORS.PRIMARY, 1)
							},
							{
								name: 'Total Impressions',
								y: this.totalImpressions,
								color: '#ddd'
							}
						]
					},
					{
						type: 'pie',
						size: '60%',
						innerSize: '40%',
						name: 'Clicks',
						data: [
							{
								name: 'Clicks',
								y: ageGroupClicks,
								color: this.colorUtilityService.getRGBByColorType(this.colorPalette, COLORS.SECONDARY, 1)
							},
							{
								name: 'Total Clicks',
								y: this.totalClicks,
								color: '#ddd'
							}
						]
					}
				];
			}
		}
		this.activeIndex = 0;
		this.donutChartData = JSON.parse(JSON.stringify(this.chartArrData));
	}

	updateChartData(legend) {
		if (legend === 'clicks') {
			this.clickState = !this.clickState;
		}
		if (legend === 'impressions') {
			this.impressionsState = !this.impressionsState;
		}
		this.updateChart();
	}
	updateChart() {
		let data = JSON.parse(JSON.stringify(this.donutChartData));
		for (const ageGroup in this.donutChartData[this.selectedGender]) {
			if (!this.clickState && this.impressionsState) {
				data[this.selectedGender][ageGroup][1].data = [];
				data[this.selectedGender][ageGroup][0].data = this.donutChartData[this.selectedGender][ageGroup][0].data;
			} else if (this.clickState && !this.impressionsState) {
				data[this.selectedGender][ageGroup][0].data = [];
				data[this.selectedGender][ageGroup][1].data = this.donutChartData[this.selectedGender][ageGroup][1].data;
			} else if (!this.clickState && !this.impressionsState) {
				data[this.selectedGender][ageGroup][0].data = [];
				data[this.selectedGender][ageGroup][1].data = [];
			} else if (this.clickState && this.impressionsState) {
				data[this.selectedGender][ageGroup] = this.donutChartData[this.selectedGender][ageGroup];
			}
		}
		this.chartArrData = JSON.parse(JSON.stringify(data));
	}
	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}
	downloadCSV() {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName
		);
	}
}
